import type { SVGProps } from 'react';

export const Star = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m8.85 16.825 3.15-1.9 3.15 1.925-.825-3.6 2.775-2.4-3.65-.325-1.45-3.4-1.45 3.375-3.65.325 2.775 2.425-.825 3.575ZM12 16.7l-3.9 2.325a.789.789 0 0 1-.425.125.835.835 0 0 1-.4-.15.87.87 0 0 1-.275-.325.664.664 0 0 1-.025-.475L8 13.8l-3.425-2.975A.742.742 0 0 1 4.35 10 .761.761 0 0 1 5 9.5l4.525-.4L11.3 4.925a.673.673 0 0 1 .275-.325.789.789 0 0 1 .425-.125.67.67 0 0 1 .4.125.637.637 0 0 1 .3.325L14.475 9.1 19 9.5c.167.017.3.075.4.175.117.083.2.192.25.325a.733.733 0 0 1-.225.825L16 13.8l1.025 4.4a.664.664 0 0 1-.025.475.87.87 0 0 1-.275.325.835.835 0 0 1-.4.15.789.789 0 0 1-.425-.125L12 16.7Z" />
    </svg>
  );
};
